import { AfterViewInit, Component, ElementRef, inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MarkdownComponent } from "ngx-markdown";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { HomePageFeature } from "src/app/common/models/home-page.model";
import { FloatingAssistantChatService } from "src/app/common/services/floating-assistant-chat.service";
import { PillarboxService } from "src/app/common/services/pillarbox.service";
import { AudioService } from "src/app/modules/audio/services/audio.service";

@Component({
  templateUrl: "./video-and-text.component.html",
  styleUrls: ["./video-and-text.component.scss"],
})
export class VideoAndTextComponent implements OnInit, OnDestroy, AfterViewInit {
  protected readonly ref = inject(DynamicDialogRef);
  protected readonly dialogConfig = inject(DynamicDialogConfig);
  protected readonly pillarboxService = inject(PillarboxService);
  protected readonly audioService = inject(AudioService);
  protected readonly floatingAssistantChatService = inject(FloatingAssistantChatService);

  @ViewChild(MarkdownComponent, { read: ElementRef }) markdownZone!: ElementRef;
  @ViewChild("container") container!: ElementRef;

  videoUrl = "";
  text = "";
  status = "";
  feature: HomePageFeature | undefined = undefined;
  videoTime = 0;
  title = "";

  ngOnInit(): void {
    this.feature = this.dialogConfig.data.feature;
    const dialogText = this.feature!.instructions || "";
    this.text = dialogText.replace(/\\n/g, "\n") || "";
    this.status = this.feature!.featureStatus || "";
    this.videoTime = this.dialogConfig.data.videoTime || 0;
    this.title = this.feature!.title;
  }

  ngOnDestroy(): void {
    this.pillarboxService.dispose();
  }

  async ngAfterViewInit(): Promise<void> {
    const mediaSource = `${this.audioService.getAwsCloudFrontDistributionUrl()}${this.feature!.videoUrl}`;
    this.pillarboxService.initOrSetSource(mediaSource, this.container, false);
    this.pillarboxService.currentTime = this.videoTime;
    await this.pillarboxService.play();

    if (this.markdownZone) {
      const links = (this.markdownZone.nativeElement as HTMLElement).querySelectorAll("a");
      for (const link of links) {
        link.addEventListener("click", (event: Event) => {
          event.preventDefault();
          void this.floatingAssistantChatService.onLinkClick(link);
        });
      }
    }
  }
}
